import { useTranslation } from 'react-i18next';
import SelectControl from '@/components/controls/select-control';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import useStore from '@/lib/store';
import { ContourItem } from '@/features/agro-technical-events/models/IAgroTechnicalEvents';

export const createSelectedColumns = ({ form, setTab }: any) => {
  const { landStatic, landTypes, fondTypes, plantsTypes, massives } =
    useStore();

  const watchedValue = useWatch({
    control: form?.control,
    name: 'value',
  }) as ContourItem[];

  const massive = useMemo(() => {
    if (!watchedValue?.[0]) return [];

    return (
      massives
        ?.filter(
          (item) => item.district_soato === watchedValue[0].district_soato,
        )
        ?.map((el) => ({ value: String(el.id), label: el.name })) || []
    );
  }, [watchedValue, massives]);

  const { t } = useTranslation();
  return [
    {
      accessorKey: 'contour_number',
      header: () => t('contour.no'),
    },
    {
      accessorKey: 'area',
      header: () => t('area'),
    },
    {
      accessorKey: 'land_type',
      header: () => t('type.land'),

      cell: ({ row }: any) => {
        const item = row.original;
        const index = watchedValue.findIndex(
          (el) => el.contour_id === item.contour_id,
        );

        return (
          <SelectControl
            notRequired
            control={form?.control}
            name={`value.${index}.land_type`}
            options={
              landStatic?.map((item) => ({
                value: String(item.id),
                label: item.name_lat,
              })) || []
            }
            className="min-w-[150px]"
          />
        );
      },
    },
    {
      accessorKey: 'land_extra_irragation',
      header: () => t('type.land'),
      cell: ({ row }: any) => {
        const item = row.original;
        const index = watchedValue.findIndex(
          (el) => el.contour_id === item.contour_id,
        );

        return (
          <SelectControl
            notRequired
            control={form?.control}
            name={`value.${index}.land_extra_irragation`}
            options={
              landTypes?.map((item) => ({
                value: String(item.id),
                label: item.name,
              })) || []
            }
            className="min-w-[150px]"
          />
        );
      },
    },
    {
      accessorKey: 'fond_type_id',
      header: () => t('land.fund.category'),
      cell: ({ row }: any) => {
        const item = row.original;
        const index = watchedValue.findIndex(
          (el) => el.contour_id === item.contour_id,
        );

        return (
          <SelectControl
            notRequired
            control={form?.control}
            name={`value.${index}.fond_type_id`}
            options={
              fondTypes?.map((item) => ({
                value: String(item.id),
                label: item.name_lat,
              })) || []
            }
            className="min-w-[150px]"
          />
        );
      },
    },
    {
      accessorKey: 'massiv_id',
      header: () => t('array'),
      cell: ({ row }: any) => {
        const item = row.original;
        const index = watchedValue.findIndex(
          (el) => el.contour_id === item.contour_id,
        );

        return (
          <SelectControl
            notRequired
            control={form?.control}
            name={`value.${index}.massiv_id`}
            options={massive || []}
            className="min-w-[150px]"
          />
        );
      },
    },
    {
      accessorKey: 'plant_type_id',
      header: () => t('plant.type'),
      cell: ({ row }: any) => {
        const item = row.original;
        const index = watchedValue.findIndex(
          (el) => el.contour_id === item.contour_id,
        );
        return (
          <SelectControl
            notRequired
            control={form?.control}
            name={`value.${index}.plant_type_id`}
            options={
              plantsTypes?.map((item) => ({
                value: String(item.id),
                label: item.name,
              })) || []
            }
            className="min-w-[150px]"
          />
        );
      },
    },
  ];
};

